module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_02@2x-12e731d9b5e072ed46005a24b7201d48.jpg";